import React, { useEffect, useState, useRef } from "react";
import Swal2 from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import "../styles/payments.css";
import LoadingPopup from "../helpers/loading_component.js";
import "react-quill/dist/quill.snow.css";
import { secretKey } from "../.././data";
import Select from "react-select";

const MySwal = withReactContent(Swal2);

const AddClientRecommendation = (props) => {
  const [loading, setLoading] = useState(true);
  const [client, setClient] = useState("");
  const [value, setValue] = useState(1000);
  const [clientsList, setClientsList] = useState([]);
  const [clientsOptions, setClientsOptions] = useState([]);

  const fetchClientsList = async () => {
    var body = {};

    await fetch("https://apidevkppp.ftpeople.pl/getClientsList", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setClientsOptions(createClientsOptions(data));
        setLoading(false);
      })
      .catch((error) => {});
  };

  const createClientsOptions = (data) => {
    var bankOptions = [];
    data.map((el) => {
      bankOptions.push({
        label: el.petitioner,
        value: el.id,
      });
    });

    return bankOptions;
  };

  const getData = async () => {
    setLoading(true);
    fetchClientsList();
  };

  useEffect(() => {
    getData();
  }, []);

  const numberWithCommas = (x) => {
    return x.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, " ");
  };

  const checkDigit = (e) => {
    if (!/^\d*\,?\d*$/.test(e.key)) {
      e.preventDefault();
    }
  };

  const validate = () => {
    if (!client && !value) {
      return false;
    }

    return true;
  };

  const generateDocument = async () => {
    if (!validate()) {
      MySwal.fire({
        icon: "error",
        title: "Uzupełnij",
        text: "wymagane pola formularza",
      }).then(async (result) => {});
      return;
    }

    var bodyX = {
      clientId: props.clientsData.id,
      recClientId: client,
      value: value,
    };

    fetch("https://apidevkppp.ftpeople.pl/addRecommendation", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(bodyX),
    })
      .then((response) => response.text())
      .then((responseJson) => {
        MySwal.fire({
          icon: "success",
          title: "Dodano",
          text: "polecenie",
        }).then(async (result) => {
          props.close();
        });
      });
  };

  const handleClientChange = (e) => {
    setClient(e.value);
  };

  return (
    <div
      style={{ width: "40vw", top: "25vh" }}
      className="mainContainerAddClientContact"
    >
      {loading ? (
        <LoadingPopup id={"popUpLoading"} />
      ) : (
        <>
          <div className="closeBox">
            <button className="closeClientButton" onClick={props.close}>
              X
            </button>
          </div>

          <div id="addPaymentIC" className="inputContainer">
            <>
              <div id="addPaymentIC" className="inputContainer">
                <div className="inputBox">
                  <div style={{ minWidth: "80%" }} className="inputCol_2">
                    <label>
                      Polecony klient
                      <span className="requiredStar">*</span>
                    </label>
                    <Select
                      noOptionsMessage={() => "Brak danych"}
                      placeholder={"Wybierz..."}
                      isClearable={false}
                      options={clientsOptions}
                      onChange={handleClientChange}
                    />
                  </div>
                </div>
                <div className="inputBox">
                  <div style={{ minWidth: "80%" }} className="inputCol_2">
                    <label>
                      Wartość polecenia
                      <span className="requiredStar">*</span>
                    </label>
                    <input
                      type="number"
                      id="name"
                      name="name"
                      value={value}
                      onChange={(e) => {
                        setValue(e.target.value);
                      }}
                    />
                  </div>
                </div>
              </div>
            </>

            <div className="saveBoxAP">
              <button className="paymentMenuButton" onClick={generateDocument}>
                ZAPISZ
              </button>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default AddClientRecommendation;
